// FUNDRAISERS
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const UPDATE_DATE = 'UpdateOnlyStartAndEnd';
export const DATE_FORMAT = 'yyyy-MM-dd';
